import React, { Fragment } from 'react';
import { withRouter } from '../../util/withRouter';
import withStyles from '@mui/styles/withStyles';
import RouteTabs from '../../component/RouteTabs';
import Paper from '@mui/material/Paper';
import Typography from '../../component/Typography';
import gql from 'graphql-tag';
import { compose, Query } from '../../reactApolloCompat';
import { applyUrlParams, joinDefined } from '../../util/strings';
import cx from 'classnames';
import { TABS } from './funeralConstants';
import DataForm from '../../component/form/DataForm';
import { SnappableLayout } from '../../component/ColumnLayout';
import { AltButton } from '../../component/form/PrimaryButton';
import AdminSummary from './adminSummary/AdminSummary';
import { loadAdminSummary, saveAdminSummaryFuncAsync } from './adminSummary/GetSaveAdminSummary';
import Spinner from '../../component/Spinner';
import GatedComponent from '../../component/GatedComponent';
import DocumentsPopover from '../funeral/documents/DocumentsPopover';
import OnlineOrderPopover from '../arrangermanager/OnlineOrderPopover';
import Button from '../workQueue2/extras/Button';
import RecordDrawer from '../workQueue2/RecordDrawer';
import Grid from '../../component/form/Grid';
import BiggerMessageBar from '../../component/BiggerMessageBar';
import Inline from '../workQueue2/extras/Inline';
import { readOnlineOrdersBtnQuery } from '../arrangermanager/OnlineOrdersConstants';
import { getClient, getMyClient } from '../../apollo';
import { getProperty } from '../../util/objects';
import Tooltip from '../../component/form/Tooltip';
import {
    ArrangementIcon,
    CartIcon,
    DocumentsIcon,
    ExclamationCircleIcon,
    NextIcon,
    QuotesIcon,
    TaskChecklistIcon,
    TickCircleIcon
} from '../../component/IconIndex';
import FlexGrid from '../workQueue2/extras/FlexGrid';
import { dayDelta } from '../../util/date';
import { withErrorBoundary } from '@sentry/react';
import ErrorFallback from '../../component/ErrorFallback';
import Hidden from '../../component/Hidden';
import SelectOffice from '../../component/form/SelectOffice';
import AlertModal from '../workQueue2/extras/AlertModal';
import { getAllOffices } from '../../util/brands';

class Funeral extends React.Component {
    state = {
        showAdminSummary: false,
        documentsModalOpen: false,
        onlineorderModalOpen: false,
        adminData: { adminSummary: null, groupedIndices: null, original: null },
        showOfficeChangeModal: false,
        selectedOfficeID: null,
        saving: false
    };

    componentDidMount() {
        loadAdminSummary(this.props.match.params.id).then(adminData => this.setState({ adminData }));
    }

    componentDidUpdate(prevProps) {
        // Check if the ID in the URL has actually changed
        if (this.props.match.params.id !== prevProps.match.params.id) {
            loadAdminSummary(this.props.match.params.id).then(adminData => this.setState({ adminData }));
        }
    }

    getCurrentTab() {
        const {
            match: {
                params: { tab }
            }
        } = this.props;
        return tab;
    }

    render() {
        const { classes, match } = this.props;
        const { key, id } = match.params;
        const { adminData, showAdminSummary, showOfficeChangeModal } = this.state;

        return (
            <Grid container>
                <Query query={nameQuery} variables={{ id, key }}>
                    {this.renderTitle}
                </Query>

                {showOfficeChangeModal && (
                    <AlertModal
                        open={showOfficeChangeModal}
                        variant="warning"
                        secondaryAction={this.state.saving ? 'Saving...' : 'Yes, I am sure'}
                        onClickSecondaryAction={() => this.handleOfficeChange()}
                        primaryAction="Cancel"
                        onClickPrimaryAction={() =>
                            this.setState({ showOfficeChangeModal: false, selectedOfficeID: null })
                        }
                        onClose={() => this.setState({ showOfficeChangeModal: false, selectedOfficeID: null })}
                        disableSecondaryAction={this.state.saving}
                        disablePrimaryAction={this.state.saving}
                    >
                        <p>You are about to change the funeral brand/office for this record.</p>
                        <p>Are you sure you want to proceed?</p>
                    </AlertModal>
                )}

                <Paper className={classes.paper} elevation={0}>
                    <SnappableLayout
                        snappableComponent={
                            showAdminSummary ? (
                                <AdminSummary
                                    currentTab={this.getCurrentTab()}
                                    {...adminData}
                                    onClose={() => this.toggleAdminSummary()}
                                    onSave={e => this.saveAdminSummary()}
                                />
                            ) : null
                        }
                    >
                        <RouteTabs tabs={TABS}>{this.renderTabs}</RouteTabs>
                    </SnappableLayout>
                </Paper>
                <DocumentsPopover
                    open={!!this.state.documentsModalOpen}
                    onClose={() => this.setState({ documentsModalOpen: false })}
                />
            </Grid>
        );
    }

    renderTitle = ({ loading, error, data }) => {
        const { classes, match } = this.props;
        const { key, id } = match.params;
        const { adminData, showAdminSummary } = this.state;
        const { DepositReceived, Created, PlaceOfService, OfficeID } = (data && data.readOneFuneral) || {};
        const { Private } = PlaceOfService || {};
        const isNotAncient = Created && dayDelta('2024-07-01', Created) > 0;
        const checklistScore =
            adminData && adminData.adminSummary && Math.round(adminData.adminSummary.AdminChecksComplete * 100);

        return (
            <Grid pc={1}>
                <Inline>
                    {((id || key) && this.renderName({ loading, error, data })) || (
                        <Typography variant="display4" gutterBottom className={classes.pageTitle}>
                            Funeral
                            <div className={classes.keyline} />
                            Unknown?
                        </Typography>
                    )}
                    <div className={classes.toolbar}>
                        {!!Private && (
                            <FlexGrid variant="justify-center" className={classes.depositNot}>
                                <ExclamationCircleIcon />
                                <small>
                                    Private
                                    <br />
                                    Service
                                </small>
                            </FlexGrid>
                        )}
                        {isNotAncient &&
                            (DepositReceived ? (
                                <FlexGrid variant="justify-center" className={classes.depositGot}>
                                    <TickCircleIcon />
                                    <small>
                                        Deposit
                                        <br />
                                        Received
                                    </small>
                                </FlexGrid>
                            ) : (
                                <FlexGrid variant="justify-center" className={classes.depositBit}>
                                    <QuotesIcon />
                                    <small>
                                        Deposit
                                        <br />
                                        Pending
                                    </small>
                                </FlexGrid>
                            ))}

                        <GatedComponent showComponentCode="ADMIN">
                            {() => (
                                <div style={{ marginBottom: -10 }}>
                                    <SelectOffice
                                        label="Office"
                                        allowRetired={false}
                                        name="SelectedFuneralBrandOffice"
                                        required={true}
                                        allowNone={false}
                                        fullWidth={false}
                                        defaultValue={OfficeID}
                                        value={this.state.selectedOfficeID}
                                        onChange={e => {
                                            this.setState({
                                                selectedOfficeID: e.target.value,
                                                showOfficeChangeModal: true
                                            });
                                        }}
                                    />
                                </div>
                            )}
                        </GatedComponent>

                        {process.env.REACT_APP_DISABLE_ARRANGEMENTS !== 'true' && (
                            <Tooltip title="Go to Documentation">
                                <AltButton
                                    className={`primary icon-button ${classes.funeralIcon}`}
                                    size="large"
                                    href={applyUrlParams('/documentation/:key/:id/summary', this.props.match.params)}
                                >
                                    <ArrangementIcon />
                                    <Hidden only={['xs', 'md']}>Documentation</Hidden>
                                    <NextIcon />
                                </AltButton>
                            </Tooltip>
                        )}

                        <Query query={readOnlineOrdersBtnQuery} variables={{ key }} client={getMyClient()}>
                            {results => this.renderOnlineOrderButton(results)}
                        </Query>

                        <Tooltip title="Generate Merge Documents">
                            <Button
                                variant={`primary icon-button white shadow ${classes.funeralIcon}`}
                                size="lg"
                                onClick={() => this.toggleDocumentModal()}
                            >
                                <DocumentsIcon />
                            </Button>
                        </Tooltip>

                        <Tooltip title="Funeral Task Queue">
                            <div>
                                <RecordDrawer funeralId={id} legacyKey={key} />
                            </div>
                        </Tooltip>

                        <GatedComponent showComponentCode={'FM_ACCESS_Funeral_Summary_View'}>
                            {() => (
                                <span className={classes.adminButton}>
                                    <Tooltip title="Funeral Checklist">
                                        <Button
                                            disableElevation
                                            variant={`primary icon-button white ${showAdminSummary && 'active'} ${
                                                classes.funeralIcon
                                            }`}
                                            size="lg"
                                            onClick={() => this.toggleAdminSummary()}
                                            className={cx(classes.funeralIcon, classes.snapButton)}
                                        >
                                            <TaskChecklistIcon />
                                            <span
                                                className={
                                                    checklistScore < 50
                                                        ? classes.depositNot
                                                        : checklistScore < 100
                                                        ? classes.depositBit
                                                        : classes.depositGot
                                                }
                                            >
                                                {!!adminData && !!adminData.adminSummary && ' ' + checklistScore + '%'}
                                            </span>
                                        </Button>
                                    </Tooltip>
                                </span>
                            )}
                        </GatedComponent>
                    </div>
                </Inline>
            </Grid>
        );
    };

    renderName = ({ loading, error, data }) => {
        const { classes } = this.props;
        const { FirstName, MiddleName, Surname, LegacyKey, Cancelled } = (data && data.readOneFuneral) || {};
        return (
            <Fragment>
                {Cancelled && <BiggerMessageBar messageType="error">This record is cancelled.</BiggerMessageBar>}
                <Typography variant="display4" gutterBottom className={classes.pageTitle}>
                    Funeral {LegacyKey}
                    <div className={classes.keyline} />
                    <small className={cx(classes.nameTitle, !loading && classes.nameTitleActive)}>
                        {joinDefined([FirstName, MiddleName, Surname], ' ')}
                    </small>
                </Typography>
            </Fragment>
        );
    };

    renderTabs = selectedIndex => {
        const { fragment } = TABS[selectedIndex];
        const { id } = this.props.match.params;

        const query = gql`
            ${fragment}
            query LoadTabData($id: ID!) {
                readOneFuneral(ID: $id) {
                    ID
                    LegacyKey
                    FirstName
                    Surname
                    MiddleName
                    LockFuneral
                    ...${fragment.definitions[0].name.value}
                }
            }
        `;

        return (
            <Query query={query} variables={{ id }}>
                {results => this.renderForm(selectedIndex, results)}
            </Query>
        );
    };

    renderForm = (selectedIndex, { loading, error, data, networkStatus, refetch }) => {
        const { classes } = this.props;
        const { id } = this.props.match.params;
        const { adminData } = this.state;
        const tab = TABS[selectedIndex];

        return (
            <GatedComponent isEnabledCode={'FM_ACCESS_Funeral_Edit'}>
                {(isEnabled, user) => (
                    <Paper className={cx(classes.bodyPadding)} elevation={0}>
                        <DataForm
                            key={id} // force mount/unmount when id in URL changed
                            id={id}
                            tab={tab}
                            loading={networkStatus !== 7}
                            error={error}
                            data={data && data.readOneFuneral}
                            allowSave={isEnabled}
                            onSaved={this.onFuneralSaved}
                            refetch={refetch}
                            requireValid={false}
                            continuousValidation={true}
                            whitelistFields={
                                !!getProperty(data, 'readOneFuneral.LockFuneral')
                                    ? [
                                          'TransferCertificates',
                                          'TransferReady',
                                          'TransferActioned',
                                          'TransferComment',
                                          'DoctorCoronerComment',
                                          'Informant.Comment',
                                          'PlaceOfService.Comment',
                                          'Clergy[].Comment',
                                          'Disposal.CemeterySection',
                                          'AshesDetail.Comment',
                                          'PlaceOfViewingItems[].Comment',
                                          'FuneralDressing.Comment',
                                          'CoffinComment',
                                          'HearseComment',
                                          'LimoBookings[].Comment',
                                          'Lifestory.PresentationFamilyToPreparePowerpointNotes',
                                          'RslMasonicComment',
                                          'DefaultMusicians[].Comment',
                                          'EnterMusicNotes',
                                          'ReflectionMusicSongs[].OtherText',
                                          'ReflectionMusicNotes',
                                          'ExitMusicNotes',
                                          'GravesideMusicNotes',
                                          'OtherMusicNotes',
                                          'RefreshmentsVenue.Comment',
                                          'Caterers[].Comment',
                                          'Florists[].Comment',
                                          'NewspaperNotices[].Comment',
                                          'NewspaperNotices[].Notes',
                                          'MemorialStationary[].Comment',
                                          'PersonalisedTouches[].Comment',
                                          'SpecialInstructions[].Comment',
                                          'BillingNotes',
                                          'FollowUpComment',
                                          'PlaceOfService.StaffAllocations[].Allocation'
                                      ]
                                    : null
                            }
                        >
                            {(form, button) => {
                                return (
                                    <Fragment>
                                        <div className={classes.content}>
                                            {!!loading && (
                                                <div className={classes.loader}>
                                                    <span>Loading data, please wait a moment...</span>
                                                    <div style={{ float: 'left', marginRight: 8 }}>
                                                        <Spinner />
                                                    </div>
                                                </div>
                                            )}
                                            <tab.component
                                                form={form}
                                                adminChecklist={tab.key === 'summary' ? adminData.adminSummary : false}
                                                user={user}
                                                locked={!!getProperty(data, 'readOneFuneral.LockFuneral')}
                                            />
                                        </div>
                                        {button}
                                    </Fragment>
                                );
                            }}
                        </DataForm>
                    </Paper>
                )}
            </GatedComponent>
        );
    };

    renderOnlineOrderButton = ({ loading, error, data, networkStatus, refetch }) => {
        const { classes } = this.props;
        const results = (data && data.readOnlineOrders && data.readOnlineOrders.edges) || [];
        if (results && results.length) {
            return results.map((onlineorder, i) => {
                return (
                    <Fragment key={i}>
                        <Tooltip title="Online Order Summary">
                            <Button
                                variant={`primary icon-button white shadow ${classes.funeralIcon}`}
                                size="lg"
                                onClick={() => this.toggleOnlineOrderModal()}
                            >
                                <CartIcon />
                            </Button>
                        </Tooltip>
                        <OnlineOrderPopover
                            orderData={onlineorder.node.OrderData}
                            open={!!this.state.onlineorderModalOpen}
                            pdfLink={onlineorder.node.SummaryPdf.AbsoluteLink}
                            onClose={() =>
                                this.setState({
                                    onlineorderModalOpen: false
                                })
                            }
                        />
                    </Fragment>
                );
            });
        }
        return null;
    };

    onFuneralSaved = () => {
        this.saveAdminSummary();
    };

    saveAdminSummary() {
        const { id } = this.props.match.params;
        const { adminData } = this.state;
        saveAdminSummaryFuncAsync(id, adminData.adminSummary, adminData.original).then(
            result => {
                loadAdminSummary(id).then(adminData => this.setState({ adminData }));
            },
            error => console.error('Error during save admin summary. e=' + error.message, error)
        );
    }

    toggleAdminSummary() {
        const { showAdminSummary } = this.state;
        this.setState({ showAdminSummary: !showAdminSummary });
    }

    toggleDocumentModal() {
        this.setState({ documentsModalOpen: true });
    }

    toggleOnlineOrderModal() {
        this.setState({ onlineorderModalOpen: true });
    }

    handleOfficeChange() {
        const { id } = this.props.match.params;
        const { selectedOfficeID } = this.state;
        const matchingOffice = getAllOffices().find(obj => Number(obj.ID) === Number(selectedOfficeID));

        this.setState({ saving: true });

        getClient()
            .mutate({
                mutation: updateFuneralOfficeMutation,
                variables: {
                    input: {
                        ID: id,
                        OfficeID: selectedOfficeID,
                        OriginatingOffice: matchingOffice.LegacyKey
                    }
                },
                refetchQueries: [
                    {
                        query: nameQuery,
                        variables: {
                            id,
                            key: this.props.match.params.key
                        }
                    }
                ]
            })
            .then(result => {
                this.setState({ saving: false, showOfficeChangeModal: false });
                loadAdminSummary(id).then(adminData => this.setState({ adminData }));

                // Update URL with new office's LegacyKey
                const newKey = result.data.updateFuneral.LegacyKey;
                const currentPath = this.props.location.pathname;
                const newPath = currentPath.replace(`/${this.props.match.params.key}/`, `/${newKey}/`);
                this.props.history.replace(newPath);
            })
            .catch(error => {
                this.setState({ saving: false });
                console.error('Error while changing office: ', error);
            });
    }
}

const nameQuery = gql`
    query NameQuery($id: ID!) {
        readOneFuneral(ID: $id) {
            ID
            LegacyKey
            Created
            LastEdited
            FirstName
            Surname
            MiddleName
            Cancelled
            DepositReceived
            OfficeID
            PlaceOfService {
                ID
                Private
            }
        }
    }
`;

const updateFuneralOfficeMutation = gql`
    mutation UpdateFuneralOffice($input: UpdateFuneralInput!) {
        updateFuneral(input: $input) {
            ID
            OfficeID
            LegacyKey
            Office {
                ID
                BusinessName
            }
        }
    }
`;

const styles = ({ spacing, typography, palette, transitions, breakpoints }) => ({
    pageTitleContainer: {
        justifyContent: 'flex-end',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        [breakpoints.down('sm')]: {
            justifyContent: 'flex-start'
        }
    },
    primaryButton: {
        [breakpoints.down('sm')]: {
            fontSize: 12
        }
    },
    adminButton: {
        margin: 0,
        marginBottom: -6,
        flexGrow: 0,
        marginRight: 16,
        position: 'relative',
        zIndex: 9,
        '&>button.icon-button.button-base': {
            border: '1px solid #d5d5d5',
            borderBottom: 'none',
            minWidth: 'unset',
            maxHeight: 'unset',
            paddingTop: 6,
            color: palette.action.active + '!important',
            '& svg + span': {
                marginLeft: spacing(1),
                fontSize: '1rem'
            }
        }
    },
    adminIcon: {
        width: '16px',
        margin: '0 0.2rem 0 0'
    },
    pageTitle: {
        color: palette.action.active,
        display: 'flex',
        alignItems: 'center',
        flexGrow: '1',
        flexWrap: 'wrap'
    },
    loader: {
        position: 'absolute',
        zIndex: 99,
        top: 0,
        left: 0,
        padding: 20,
        height: '100%',
        width: '100%',
        background: 'rgba(255,255,255,0.5)'
    },
    keyline: {
        width: 1,
        height: 30,
        display: 'inline-block',
        margin: '0 16px',
        opacity: 0.5,
        backgroundColor: palette.action.active
    },
    nameTitle: {
        display: 'inline-block',
        fontWeight: typography.fontWeightLight,
        // marginLeft: 16,
        opacity: 0,
        color: palette.text.primary,
        [breakpoints.down('sm')]: {
            // marginLeft: 0
        },
        transition: transitions.create(['opacity'], {
            easing: transitions.easing.sharp,
            duration: transitions.duration.enteringScreen
        })
    },
    nameTitleActive: {
        opacity: 1
    },
    paper: {
        width: '100%',
        '& > div': {
            marginBottom: 0,
            [breakpoints.down('sm')]: {
                '& > div:nth-child(2)': {
                    zIndex: 1
                }
            }
        }
    },
    toolbar: {
        position: 'relative',
        zIndex: 3, // affects taskqueue drawer
        display: 'flex',
        flexWrap: 'nowrap',
        flex: '1 1 auto',
        alignItems: 'center',
        justifyContent: 'end',
        marginBottom: 4,
        marginTop: '0!important',
        height: 54,
        gap: '8px 16px'
    },
    snapButton: {
        borderRadius: '24px 24px 0 0!important',
        height: 58
    },
    funeralIcon: {
        maxHeight: 49,
        '&.white span > svg': {
            color: palette.primary.main + '!important'
        },
        '&.border': {
            border: '1px solid #e0e0e0!important'
        },
        '&.active': {
            borderColor: palette.primary.main + '!important'
        },
        '&:not(.white)': {
            minWidth: 'unset',
            padding: 14,
            '& span > svg': {
                fontSize: '1.15em',
                width: '1em',
                height: '1em'
            }
        }
    },
    depositGot: {
        color: palette.validation.good,
        columnGap: 6
    },
    depositBit: {
        color: palette.validation.suggested,
        columnGap: 6
    },
    depositNot: {
        color: palette.validation.error,
        columnGap: 6
    },
    privateDancer: {
        color: palette.validation.error,
        border: '1px dotted ' + palette.validation.error,
        borderRadius: 5,
        lineHeight: 1,
        padding: '4px 8px 3px 8px',
        background: palette.validation.error + '09',
        fontSize: '0.785rem',
        display: 'block',
        textAlign: 'center'
    },
    bodyPadding: {
        borderRadius: '0!important',
        borderWidth: '0!important'
    },
    content: {
        padding: `${spacing(3)} 0`,
        [breakpoints.down('lg')]: {
            padding: spacing(2)
        }
    }
});

// prettier-ignore
export default withErrorBoundary(
    compose(withRouter, withStyles(styles))(Funeral),
    { fallback: ErrorFallback }
);
